import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { excludeAttractionOffer } from '~/services/AttractionsService';

import { setCacheBuster } from './attractionCacheBuster';
import { attractionQueryKeys } from './attractionQueryKeys';

interface ExcludeAttractionOfferData {
  attractionId: string;
  offerId: string;
}

export function useExcludeAttractionOffer() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ attractionId, offerId }: ExcludeAttractionOfferData) => {
      return await excludeAttractionOffer(attractionId, offerId);
    },
    onSuccess: (_data, { attractionId }) => {
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.offers(attractionId) });
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.detail(attractionId) });
      setCacheBuster(attractionId, Date.now().toString());
      enqueueSnackbar('Offer excluded from attraction', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error excluding offer: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
